import { Center, Divider, Loader } from "@mantine/core";
import { formatNZD } from "common/utils";

import { safeApiCall } from "api/common.service";
import { getDebtorBalanceSummary } from "api/report.service";
import React, { useEffect, useState } from "react";
import { RptDebtorBalanceSummary } from "types/model.types";

const DebtorBalancePreview: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<RptDebtorBalanceSummary | null>();

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        const result = await safeApiCall(getDebtorBalanceSummary());
        if (mounted && result) setData(result?.data[0] ?? null);
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  if (loading) {
    return (
      <Center style={{ height: "100vh" }}>
        <Loader size="lg" />
      </Center>
    );
  }

  return (
    <>
      <div className="sub-title">Customer Orders Report</div>

      {data && (
        <table className="print-table">
          <tbody>
            <tr>
              <td className="leftCol">Opening</td>
              <td className="em-text">{formatNZD(data.opening)}</td>
            </tr>
            <tr>
              <td colSpan={2}>
                <Divider className="divider" />
              </td>
            </tr>
            <tr>
              <td className="leftCol">Current</td>
              <td className="em-text">{formatNZD(data.currentMonth)}</td>
            </tr>
            <tr>
              <td className="leftCol">30 Days</td>
              <td className="em-text">{formatNZD(data.month1)}</td>
            </tr>
            <tr>
              <td className="leftCol">60 Days</td>
              <td className="em-text">{formatNZD(data.month2)}</td>
            </tr>
            <tr>
              <td className="leftCol">90 Days</td>
              <td className="em-text">{formatNZD(data.month3)}</td>
            </tr>
            <tr>
              <td colSpan={2}>
                <Divider className="divider" />
              </td>
            </tr>
            <tr>
              <td className="leftCol">Balance</td>
              <td className="em-text">{formatNZD(data.balance)}</td>
            </tr>
            <tr>
              <td colSpan={2}>
                <Divider className="divider" />
              </td>
            </tr>
            <tr>
              <td className="leftCol">Difference</td>
              <td className="em-text">{formatNZD(data.imBalance)}</td>
            </tr>
            <tr>
              <td colSpan={2}>
                <Divider className="divider" />
              </td>
            </tr>
            <tr>
              <td className="leftCol">Sales MTD</td>
              <td className="em-text">{formatNZD(data.salesMtd)}</td>
            </tr>
            <tr>
              <td className="leftCol">Cash MTD</td>
              <td className="em-text">{formatNZD(data.cashMtd)}</td>
            </tr>
            <tr>
              <td className="leftCol">GST MTD</td>
              <td className="em-text">{formatNZD(data.gstMtd)}</td>
            </tr>
          </tbody>
        </table>
      )}
    </>
  );
};

export default DebtorBalancePreview;
